var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgCross = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "m13.414 12 5.657-5.657-1.414-1.414L12 10.586 6.343 4.929 4.93 6.343 10.586 12l-5.657 5.657 1.414 1.414L12 13.414l5.657 5.657 1.414-1.414L13.414 12Z", fill: "currentColor" }));
export { SvgCross as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTEzLjQxNCAxMiA1LjY1Ny01LjY1Ny0xLjQxNC0xLjQxNEwxMiAxMC41ODYgNi4zNDMgNC45MjkgNC45MyA2LjM0MyAxMC41ODYgMTJsLTUuNjU3IDUuNjU3IDEuNDE0IDEuNDE0TDEyIDEzLjQxNGw1LjY1NyA1LjY1NyAxLjQxNC0xLjQxNEwxMy40MTQgMTJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";
